import { get, apiPrefix } from './common';
const getAchConfig = () => get(`${apiPrefix}/ach-config`);
export default getAchConfig;
